import { lazy, Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import { RouteErrorComponent } from '@/features/app-shell/route-error-component'
import { GraylogDashboardSkeleton } from '@/features/graylog/alerts/components/skeletons'
import { graylogQueries } from '@/features/graylog/queries'

import { getCurrentTenant } from '@/shared/auth/store'

import { ErrorBoundary } from '@/components/common/error-boundary'

const GraylogDashboard = lazy(
	() => import('@/features/graylog/alerts/components/dashboard'),
)

export const Route = createFileRoute('/_dashboard/graylog/alerts')({
	loader: ({ context: { queryClient } }) => {
		const tenant = getCurrentTenant()

		if (tenant) {
			queryClient.prefetchQuery(graylogQueries.triggeredAlerts(tenant))
		}
	},

	head: () => ({
		meta: [
			{
				title: 'Alerts | Graylog | BitLyft AIR®',
			},
		],
	}),

	component: AlertsRoute,
	pendingComponent: GraylogDashboardSkeleton,
	errorComponent: RouteErrorComponent,
})

function AlertsRoute() {
	return (
		<ErrorBoundary feature="graylog-alerts">
			<div className="flex w-full flex-col items-start justify-start gap-4">
				<Suspense fallback={<GraylogDashboardSkeleton />}>
					<GraylogDashboard />
				</Suspense>
			</div>
		</ErrorBoundary>
	)
}
